import {
    ABOUT_ROUTE,
    CATALOG_ROUTE,
    CATEGORY_BLOCK_HOUSE, CATEGORY_EDGED_BOARD, CATEGORY_EVRO_VAGONKA, CATEGORY_FLOOR_BOARD,
    CATEGORY_IMITATION_TIMBER, CATEGORY_PLANED_BLOCK,
    CATEGORY_PLANED_BOARD, CATEGORY_SHTIL, CONTACT,
    INDEX_ROUTE, PHOTO_ROUTE, PRIVACY_POLICY
} from "./utils/consts";
import Index from "./pages/Index";
import Catalog from "./pages/Catalog";
import Product from "./pages/Product";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Photo from "./pages/Photo";
import PrivacyPolicy from "./pages/PrivacyPolicy";

export const publicRoutes = [
    {
        path: INDEX_ROUTE,
        component: <Index/>
    },
    {
        path: CATALOG_ROUTE,
        component: <Catalog/>
    },
    {
        path: CATEGORY_PLANED_BOARD,
        component: <Catalog/>
    },
    {
        path: CATEGORY_PLANED_BLOCK,
        component: <Catalog/>
    },
    {
        path: CATEGORY_EDGED_BOARD,
        component: <Catalog/>
    },
    {
        path: CATEGORY_BLOCK_HOUSE,
        component: <Catalog/>
    },
    {
        path: CATEGORY_IMITATION_TIMBER,
        component: <Catalog/>
    },
    {
        path: CATEGORY_SHTIL,
        component: <Catalog/>
    },
    {
        path: CATEGORY_FLOOR_BOARD,
        component: <Catalog/>
    },
    {
        path: CATEGORY_FLOOR_BOARD,
        component: <Catalog/>
    },
    {
        path: CATEGORY_EVRO_VAGONKA,
        component: <Catalog/>
    },
    {
        path: CATALOG_ROUTE + '/:id',
        component: <Product/>
    },
    {
        path: CONTACT,
        component: <Contact/>
    },
    {
        path: ABOUT_ROUTE,
        component: <About/>
    },
    {
        path: PHOTO_ROUTE,
        component: <Photo/>
    },
    {
        path: PRIVACY_POLICY,
        component: <PrivacyPolicy/>
    }
]